/**
 * 호스트 구조 (CR-040): 서비스 사이트 = isms-p.kr·www, 웹앱 = app.isms-p.kr, 그 밖(커스텀 도메인·localhost) = 앱.
 * 사이트 호스트 목록은 빌드 변수 VITE_SITE_HOSTS(쉼표 구분, 기본 isms-p.kr,www.isms-p.kr).
 * 개발(localhost)은 앱이 기본이고, ?site=1 또는 site.localhost 로 사이트를 본다.
 */
const SITE_HOSTS = (import.meta.env.VITE_SITE_HOSTS ?? 'isms-p.kr,www.isms-p.kr').split(',').map((s: string) => s.trim().toLowerCase()).filter(Boolean);
const APP_HOST = (import.meta.env.VITE_APP_HOST ?? 'app.isms-p.kr').toLowerCase();

export const hostname = () => window.location.hostname.toLowerCase();
export const isLocalHost = (h = hostname()) => h === 'localhost' || h === '127.0.0.1' || h.endsWith('.localhost');
export function isSiteHost(h = hostname()): boolean {
  if (isLocalHost(h)) return h.startsWith('site.') || new URLSearchParams(window.location.search).get('site') === '1';
  return SITE_HOSTS.includes(h);
}
/** 우리 호스트(앱·사이트·www·localhost)가 아니면 커스텀 도메인 */
export const isCustomDomain = (h = hostname()) => !isLocalHost(h) && !SITE_HOSTS.includes(h) && h !== APP_HOST;
/** 앱 오리진: 사이트에서 앱으로 보낼 때 (localhost 는 같은 오리진) */
export function appOrigin(): string {
  const h = hostname();
  if (isLocalHost(h)) return window.location.origin.replace(/\/$/, '');
  if (SITE_HOSTS.includes(h)) return `https://${APP_HOST}`;
  return window.location.origin;
}
/** 사이트 오리진: 앱에서 서비스 소개로 보낼 때 */
export function siteOrigin(): string {
  const h = hostname();
  if (isLocalHost(h)) return `${window.location.origin}/?site=1`;
  return `https://${SITE_HOSTS[0] ?? 'isms-p.kr'}`;
}

/** 공개 문서 URL (CR-040): 커스텀 도메인이면 짧은 경로, 아니면 앱 호스트 + 조직 ID 경로 */
export function publicDocUrl(orgId: string | undefined, publicSlug: string, file = ''): string {
  const tail = `policies/${publicSlug}/${file}`;
  if (isCustomDomain()) return `${window.location.origin}/${tail}`;
  return `${appOrigin()}/${orgId ?? '{orgId}'}/${tail}`;
}
